import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const Container = styled.div`
  padding: 16px 12px;
  .hint {
    font-size: ${Variables.font_sizes.x1_medium};
    color: ${Variables.colors.complementary_700};
    line-height: 1.56;
    margin-bottom: 16px;
  }
`;

export const CardPanel = styled.div`
  padding: 14px 12px;
  margin-bottom: 16px;
  background-color: ${Variables.colors.complementary_50};
  box-shadow: 0 1px 6px 0 #ccc;
  border-radius: 10px;
  cursor: pointer;
  &:hover {
    background-color: ${Variables.colors.complementary_200};
  }
  .top-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    .role-icon {
      margin-left: 8px;

      &:before {
        font-size: 28px;
        color: ${Variables.colors.complementary_900};
      }
    }

    .user-team {
      color: ${Variables.colors.complementary_600};
      width: 100%;
      margin-right: 6px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      & > span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100%;

        :last-child {
          font-size: ${Variables.font_sizes.x_small};
          color: ${Variables.colors.complementary_600};
        }
      }
    }
  }
  .bottom-row {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .text {
      font-size: ${Variables.font_sizes.small};
      color: ${Variables.colors.tertiary_700};
    }
    .arrow-icon {
      margin-right: 4px;
      display: flex;
      &:before {
        font-size: 10px;
        color: ${Variables.colors.tertiary_700};
      }
    }
  }
`;
